import { call, takeEvery, put, select } from 'redux-saga/effects';
import * as autoSearchActions from '../actions/autoSearchActions';
import * as getFieldsActions from '../actions/getFieldsActions';
import { errorProcessing } from '../../../Employees/api/errorProcessing';
import { autoSearchByNumRequest } from '../../api/vehicleCard/autoSearch';
import { getModelsByBrandRequest } from '../../api/vehicles/getFieldsRequests/getModelsByBrandRequest';

// function* autoSearchSaga(action) {
// 	try {
// 		const { payload } = action;
// 		console.log('autoSearchSaga', payload);
// 		const response = yield call(autoSearchRequest, payload);
// 		if (response.data.length) {
// 			console.log('AutoSearch Saga Success data', response.data);
// 			yield put(loginActions.autoSearchSuccess(response));
// 		} else {
// 			throw response;
// 		}
// 	} catch (error) {
// 		// console.log('AutoSearch Saga Error response', error);
// 		yield put(loginActions.autoSearchError(error));
// 	}
// }

function* autoSearchByNumSaga(action) {
  try {
    const { payload } = action;
    let response = yield call(autoSearchByNumRequest, payload);
    // console.log('response', response);
    if (Object.keys(response).length > 0) {
      const brand = response.brandName && response.brandName.toUpperCase();
      if (brand) {
        // Ищем бренд в справочнике
        const brandId = yield select(state => {
          return state.Transport.Fields.brandsTypes.find(
            item => item.brandName.toUpperCase() === brand
          );
        });
        if (brandId) {
          response.brand = brandId.vehicleBrandId;

          const model = response.modelName && response.modelName.toUpperCase();
          if (model && response.brand) {
            const responseModel = yield call(
              getModelsByBrandRequest,
              response.brand
            );
            yield put(getFieldsActions.getModelsByBrandSuccess(responseModel));

            const modelId =
              responseModel &&
              responseModel.data &&
              responseModel.data.find(
                item => item.modelName.toUpperCase() === model
              );
            if (modelId) {
              response.model = modelId.vehicleModelId;
            }
          }
        }
        const category =
          response.categoryName && response.categoryName.toUpperCase();
        if (category) {
          const categoryId = yield select(state => {
            return state.Transport.Fields.categoriesTypes.find(
              item => item.categoryName.toUpperCase() === category
            );
          });
          if (categoryId) {
            response.category = categoryId.vehicleCategoryId;
          }
        }

        const color = response.colorName && response.colorName.toUpperCase();
        if (color) {
          const colorId = yield select(state => {
            return state.Transport.Fields.colorsTypes.find(
              item => item.colorName.toUpperCase() === color
            );
          });
          if (colorId) {
            response.color = colorId.vehicleColorId;
          }
        }

        const vehicleType =
          response.vehicleTypeName && response.vehicleTypeName.toUpperCase();
        if (vehicleType) {
          const vehicleTypeId = yield select(state => {
            return state.Transport.Fields.vehicleTypes.find(
              item => item.vehicleType.toUpperCase() === vehicleType
            );
          });
          if (vehicleTypeId) {
            response.vehicleType = vehicleTypeId.vehicleTypeId;
          }
        }
      }
      // console.log('BRAND=', response);
      yield put(autoSearchActions.autoSearchByNumSuccess(response));
    } else {
      yield put(
        autoSearchActions.autoSearchByNumError({
          message: 'Нет данных по указанному регистрационному знаку',
        })
      );
    }
  } catch (error) {
    yield put(autoSearchActions.autoSearchByNumError(errorProcessing(error)));
  }
}

export function* autoSearchWatcher() {
  // yield takeEvery(loginActions.autoSearch.toString(), autoSearchSaga);
  yield takeEvery(
    autoSearchActions.autoSearchByNum.toString(),
    autoSearchByNumSaga
  );
}
